module.exports = __webpack_public_path__ + "img/duplicate-mobole-number.517a20b8.png";